module.exports = __webpack_public_path__ + "static/publication-cover-db9009e5c68f4664e3b4d4f1a145a365.png";